var exports = {
  "A": "quickSearchInput-ZG05d",
};

module.exports = exports;
